export default {
  state: {
    isLoading: false
  },
  mutations: {
    setLoading (state, isLoading) {
      state.isLoading = isLoading
    }
  }
}